import React, {FC, createContext, useContext, useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {BrowserRouter} from "react-router-dom"
import {checkIsGuest} from './api'
import Header from "./components/Header"
import Auth from "./components/Auth"
import Footer from "./components/Footer"
import ProLayout from './components/ProLayout'
import redirect from './utils/redirect'

const appContext: any = createContext({})

// For dev test: 'pro' | 'default'
const devType: string = ''

export const useAppContext = () => {
  return useContext<any>(appContext)
}

const AppContext: FC = () => {
  const dispatch = useDispatch()
  const [lang, setLang] = useState<string>('')
  const [appType, setAppType] = useState<string>('default')
  const langRedux = useSelector(({reducer}: any) => reducer.lang)
  const showCaptcha = useSelector(({reducer}: any) => reducer.showCaptcha)
  const baseUrl = useSelector(({reducer}: any) => reducer.baseUrl)
  const isGuest = useSelector(({reducer}: any) => reducer.isGuest)

  useEffect(() => {
    const langLocal = localStorage.getItem('lang')
    const showCaptchaLocal = localStorage.getItem('showCaptcha')

    if ( langLocal && langLocal !== langRedux )
      dispatch({type: 'SET_LANG', payload: langLocal})
    else
      dispatch({type: 'SET_LANG', payload: navigator.language.substr(0,2)})

    if ( showCaptchaLocal && showCaptchaLocal !== showCaptcha )
      dispatch({type: 'SET_SHOW_CAPTCHA', payload: showCaptchaLocal})

    dispatch({
      type: 'SET_BASE_URL',
      payload: `${window.location.protocol}//${window.location.hostname}`
    })

    if (!window.location.pathname.startsWith('/user/recover')) {
      checkIsGuest()
        .then(res => dispatch({type: 'SET_IS_GUEST', payload: res.isGuest}))
    }
  }, [])

  useEffect(() => {
    if ( baseUrl ) {
      if ( devType === 'default' || baseUrl.includes('.be') )
        setAppType('default')

      if ( devType === 'pro' || baseUrl.includes('.pro') )
        setAppType('pro')
    }
  }, [baseUrl])

  useEffect(() => {
    if ( appType ) {
      if ( appType === 'default' )
        document.querySelector('body')!.className = 'default'

      if ( appType === 'pro' )
        document.querySelector('body')!.className = 'pro'
    }
  }, [appType])

  useEffect(() => {
    if ( langRedux ) setLang(langRedux)
  }, [langRedux])

  if ( isGuest === false ) redirect(appType)

  return (isGuest) && (
    <appContext.Provider value={{lang, appType}}>
      {appType === 'default' ? (
        <React.StrictMode>
          <BrowserRouter>
            <Header/>
            <Auth/>
          </BrowserRouter>

          <Footer/>
        </React.StrictMode>
      ) : appType === 'pro' && (
        <React.StrictMode>
          <BrowserRouter>
            <ProLayout>
              <Auth/>
            </ProLayout>
          </BrowserRouter>
        </React.StrictMode>
      )}
    </appContext.Provider>
  )
}

export default AppContext
